import { render, staticRenderFns } from "./ShoppingGuide.vue?vue&type=template&id=96648160&"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js&"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingGuide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96648160')) {
      api.createRecord('96648160', component.options)
    } else {
      api.reload('96648160', component.options)
    }
    module.hot.accept("./ShoppingGuide.vue?vue&type=template&id=96648160&", function () {
      api.rerender('96648160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/ShoppingGuide.vue"
export default component.exports